export default __webpack_public_path__ + "static/media/Utkarsh.25452c91.png";